import { Menu } from '@mantine/core';
import { CameraControls } from '@react-three/drei';
import { Icon } from '@uag/react-core';
import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface FocusBuildingProps {
    cameraControlsRef: RefObject<CameraControls | null>;
    domElement: HTMLCanvasElement | null;
}

export const FocusBuilding = ({ cameraControlsRef, domElement }: FocusBuildingProps) => {
    const { t } = useTranslation();
    const setFocusOnBuilding = usePlacementStore(useShallow((state) => state.setFocusOnBuilding));

    return (
        <Menu.Item
            leftSection={
                <Icon
                    className="action-menu-entry-decoration action-menu-entry-decoration-icon"
                    icon="view_in_ar"
                />
            }
            rightSection={<ActionShortcutHint actionId={InputActionId.CameraCenter} className="min-w-20" />}
            onClick={() => setFocusOnBuilding(cameraControlsRef, domElement)}
        >
            {t('buttonFocusBuilding')}
        </Menu.Item>
    );
};
